import React from 'react';

import clsx from 'clsx';

import { InfoIcon, AttentionIcon } from 'components/Icons';

import styles from './InfoMessage.module.scss';

export interface InfoMessageProps {
  title: (() => JSX.Element) | string;
  type: InfoMessageType;
  text?: string;
  containerClassname?: string;
  iconClassname?: string;
}

export enum InfoMessageType {
  Attention = 'Attention',
  Information = 'Information',
}

const InfoMessage = ({ title, type, text, containerClassname, iconClassname }: InfoMessageProps) => {
  const iconByTypeMap = new Map<InfoMessageType, JSX.Element>([
    [InfoMessageType.Attention, <AttentionIcon iconClassName={iconClassname} />],
    [InfoMessageType.Information, <InfoIcon iconClassName={clsx(styles.icon, iconClassname)} />],
  ]);

  return (
    <div className={clsx(styles.container, containerClassname)}>
      <div className={styles.titleContainer}>
        {iconByTypeMap.get(type)}
        <p className={clsx('subtitle-medium', styles.text)}>{typeof title === 'string' ? title : title()}</p>
      </div>
      {text && <p className={clsx('subtitle-small--alternative', styles.text, styles.subtitle)}>{text}</p>}
    </div>
  );
};

export default InfoMessage;
